import EnvHelper from "./env-helper";
import StringHelper from "./string-helper";

export default class Api {
	static get currentCityId() {
		return EnvHelper.currentCityId;
	}

	static get restSiteUrl() {
		return craft.env.restSiteUrl;
	}

	static get apiSiteUrl() {
		return craft.env.apiSiteUrl;
	}

	static get lmsUrl() {
		return 'https://lms.ithillel.ua'
	}

	static get lmsApiUrl() {
		return 'https://lms.ithillel.ua/api/lms'
	}

	static setQueryParams(url, params = {}, options = {}) {
		if (typeof params !== 'object' || !Object.keys(params).length) {
			return url;
		}
		const overwrite = options.overwrite == null ? false : options.overwrite;

		// Extract predefined params
		// and overwrite passed params if overwrite option is set to false
		const chunks = url.split('?');

		if (chunks.length > 1) {
			url = chunks[0];

			const chunks_predefinedParams = chunks[1].split('&');

			chunks_predefinedParams.forEach((chunk) => {
				const paramEntry = chunk.split('=');

				if (!overwrite) {
					params[paramEntry[0]] = paramEntry[1];
				} else {
					if (!params.hasOwnProperty([paramEntry[0]])) {
						params[paramEntry[0]] = paramEntry[1];
					}
				}
			});
		}

		const paramKeys = Object.keys(params);

		if (paramKeys.length) {
			paramKeys.forEach((paramKey, index) => {
				url += (index === 0 ? '?' : '&');
				url += `${paramKey}=${params[paramKey]}`;
			});
		}

		return url;
	}

	static get(url, params = {}, options = {}) {
		if (!url) {
			throw new Error('Api/get: url parameter is not defined.');
		}

		url = Api.setQueryParams(url, params);

		return axios.get(url, options)
			.then((res) => {
				let data = res.data;

				if (typeof data === 'string') {
					data = data.trim();
				}

				return data;
			});
	}

	static post(url, data) {
		return axios.post(url, data)
			.catch((err) => {
				console.error('Api / post:', err);
			});
	}

	static sendFbEvent(eventName, data = {}) {
		if (eventName == null) return;
		if (typeof data != 'object') return;

		let formCachedData = localStorage.getItem('formValues');
		formCachedData = formCachedData ? JSON.parse(formCachedData) : {};

		let cityId = craft.env.cityId ? craft.env.cityId : Api.currentCityId;
		cityId = cityId != 'online' ? cityId : null;

		data = Object.assign({
			eventName,
			city: cityId,
			fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
			fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
			referrer: location.href
		}, formCachedData, data);

		Api.post(`${Api.restSiteUrl}/2.0/facebook/event`, data);
	}

	static updateAndReturnDataWithUtmTags(data = {}) {
		const updatedData = {};
		const utmTagKeys = ['utmSource', 'utmCampaign', 'utmMedium', 'utmTerm', 'utmContent'];

		Object.assign(updatedData, data);

		for (const utmTagKey of utmTagKeys) {
			const utmTagJsonDataFromStorage = localStorage.getItem(utmTagKey);
			const utmTagDataFromStorage = utmTagJsonDataFromStorage ? JSON.parse(utmTagJsonDataFromStorage) : null;

			if (utmTagDataFromStorage && typeof utmTagDataFromStorage === 'object') {
				const nowDate = new Date();
				const utmTagDate = new Date(utmTagDataFromStorage.date);
				const diffTime = Math.abs(nowDate - utmTagDate);
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

				if (diffDays < 7) {
					updatedData[utmTagKey] = utmTagDataFromStorage.value;
				}
			}
		}

		return updatedData;
	}

	static updateUrlWithUtmTagQueryParams(url) {
		const utmTagKeys = ['utmSource', 'utmCampaign', 'utmMedium', 'utmTerm', 'utmContent'];
		const queryParamsObj = {};

		for (const utmTagKey of utmTagKeys) {
			const utmTagJsonDataFromStorage = localStorage.getItem(utmTagKey);
			const utmTagDataFromStorage = utmTagJsonDataFromStorage ? JSON.parse(utmTagJsonDataFromStorage) : null;

			if (utmTagDataFromStorage && typeof utmTagDataFromStorage === 'object') {
				const utmTagQueryParamKey = `utm_${StringHelper.decapitalize(utmTagKey.slice(3))}`;
				queryParamsObj[utmTagQueryParamKey] = utmTagDataFromStorage.value;
			}
		}

		return Api.setQueryParams(url, queryParamsObj);
	}
}